<template>
    <v-dialog v-model="showModalModel" max-width="500">
        <v-card>
            <v-card-text>
                <p class="title text-xs-center mb-0">
                    {{ 'LIMIT_PER_STOCK_MODAL_MESSAGE' | translation }}
                </p>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-flex xs3>
                    <v-btn block class="ml-0" color="primary" @click.stop="showModalModel = false">
                        {{ 'Close' | translation }}
                    </v-btn>
                </v-flex>
                <v-spacer />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const parentModuleName = 'Product';
const { mapState, mapMutations } = createNamespacedHelpers(parentModuleName);

export default {
    computed: {
        ...mapState({
            showModal: state => state.showLimitPerOrderModal,
        }),
        showModalModel: {
            get() {
                return this.showModal;
            },
            set(value) {
                this.setShowLimitPerOrderModal(value);
            },
        },
    },
    methods: {
        ...mapMutations(['setShowLimitPerOrderModal']),
    },
};
</script>
